import { Form } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { NumberWithUnit } from 'app/components/commons/NumberWithUnit/NumberWithUnit';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { EXPERIENCE_DURATION_DESCRIPTION } from 'app/typings/core/common/experiences/enum/experienceDurationDescription';
import { parseUppercaseSnakeTextToCapitalize } from 'app/utils/string';

export const Duration = () => {
  const { isViewMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const durationValue = Form.useWatch('duration', form);
  const durationDescriptionValue = Form.useWatch('durationDescription', form);

  return (
    <FormLineLayout
      label="Duration"
      description="If applicable, it will be highlighted in the activity title"
    >
      <Form.Item>
        <div className="FIELD">
          <div className="not-price-kind">
            {isViewMode ? (
              <span className="view-data">
                <Form.Item name="duration" noStyle>
                  <span>{durationValue}</span>
                </Form.Item>
                <Form.Item name="durationDescription" noStyle>
                  {durationDescriptionValue && (
                    <span>
                      {parseUppercaseSnakeTextToCapitalize(
                        durationDescriptionValue
                      )}
                    </span>
                  )}
                </Form.Item>
              </span>
            ) : (
              <NumberWithUnit
                numberFormName="duration"
                unitFormName="durationDescription"
                disabled={false}
                min={1}
                isSmallSelect
                unitOptions={[
                  { key: 'empty', value: 'empty', label: ' ' },
                  ...Object.values(EXPERIENCE_DURATION_DESCRIPTION).map(
                    (description) => ({
                      key: description,
                      value: description,
                      label: parseUppercaseSnakeTextToCapitalize(description),
                    })
                  ),
                ]}
              />
            )}
          </div>
        </div>
      </Form.Item>
    </FormLineLayout>
  );
};
